module.exports = __webpack_public_path__ + "media/ab-homepage/storage-2e19bc16.png";